var Chaplin, support, utils;

Chaplin = require('chaplin');

utils = require('base/lib/utils');

support = utils.beget(Chaplin.support);

module.exports = support;
